import { Injectable } from '@angular/core';

// The Tizen AVPlay api allows for there to be ONE listener only
// and there is no unsubscribe
//
// This does not support our model where there are having multiple video feeds
//
// This class wraps the AVPlay api and allows for multiple listeners
// and unsubscribing

@Injectable({
    providedIn: "root"
})
export class TizenAvPlaySharedListener {
    
    private readonly subscribers : AVPlayPlaybackCallback[] = [];

    private hasSetListener = false;

    private forEachSubsriber(action: (AVPlayPlaybackCallback) => void) : void {
        for(let i = 0; i < this.subscribers.length; ++i) {
            action(this.subscribers[i]);
        }
    }

    private listenToPlayerManager() : void {
        const playerManager = (webapis || { avplay: undefined}).avplay;
        if (!playerManager) {
            return;
        }
        playerManager.setListener({
            onbufferingcomplete : () => this.forEachSubsriber(s => s.onbufferingcomplete()),
            onbufferingstart: () => this.forEachSubsriber(s => s.onbufferingstart()),
            onstreamcompleted: () => this.forEachSubsriber(s => s.onstreamcompleted()),
            onerror : () => this.forEachSubsriber(s => s.onerror())
        });
    }
    
    public subscribe(callback: AVPlayPlaybackCallback) {
        const existing = this.subscribers.indexOf(callback);
        if (existing === -1) {
            this.subscribers.push(callback);
        }
        if (!this.hasSetListener) {
            this.hasSetListener = true;
            this.listenToPlayerManager();
        }
    }

    public unsubscribe(callback: AVPlayPlaybackCallback) {
        const existingIndex = this.subscribers.indexOf(callback);
        if (existingIndex !== -1) {
            this.subscribers.splice(existingIndex, 1);
        }
    }
}